import React, {ReactNode} from 'react';
import {connect} from "react-redux";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {IelTiempoData, IPointCoords, INotificacion} from "../../types";
import axios from "axios";
import {Typography} from "@material-ui/core";

import Icon01d from "../../icons/weather/01d.svg"
import Icon01n from "../../icons/weather/01n.svg"
import Icon02d from "../../icons/weather/02d.svg"
import Icon02n from "../../icons/weather/02n.svg"
import Icon03d from "../../icons/weather/03d.svg"
import Icon03n from "../../icons/weather/03n.svg"
import Icon04d from "../../icons/weather/04d.svg"
import Icon04n from "../../icons/weather/04n.svg"
import Icon09d from "../../icons/weather/09d.svg"
import Icon09n from "../../icons/weather/09n.svg"
import Icon10d from "../../icons/weather/10d.svg"
import Icon10n from "../../icons/weather/10n.svg"
import Icon11d from "../../icons/weather/11d.svg"
import Icon11n from "../../icons/weather/11n.svg"
import Icon13d from "../../icons/weather/13d.svg"
import Icon13n from "../../icons/weather/13n.svg"
import Icon50d from "../../icons/weather/50d.svg"
import Icon50n from "../../icons/weather/50n.svg"
import Icon1232n from "../../icons/weather/1232n.svg"

const texts = require('../../texts/eltiempo.json')

const selectIcon = (id: string) => {
    switch (id) {
        case '01d': return Icon01d
        case '01n': return Icon01n
        case '02d': return Icon02d
        case '02n': return Icon02n
        case '03d': return Icon03d
        case '03n': return Icon03n
        case '04d': return Icon04d
        case '04n': return Icon04n
        case '09d': return Icon09d
        case '09n': return Icon09n
        case '10d': return Icon10d
        case '10n': return Icon10n
        case '11d': return Icon11d
        case '11n': return Icon11n
        case '13d': return Icon13d
        case '13n': return Icon13n
        case '50d': return Icon50d
        case '50n': return Icon50n
        case '1232n': return Icon1232n
        default: return undefined

    }
}

interface IProps {
    setElTiempoData(elTiempoData: IelTiempoData): void
    notify(notification: INotificacion): void
    LatLon: IPointCoords
    data: IelTiempoData
    idioma: string
}

interface IState {
    apikey: string
    text: Record<string, string>
}


class ElTiempo extends React.Component<IProps, IState> {

    state = {
        apikey: '183226ff5884167b6962c542db9e013d',
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        if (this.props.LatLon !== nextProps.LatLon) {
            setTimeout(() => this.componentDidMount(), 1)
        }
        return true
    }

    componentDidMount() {
        const url = `https://api.openweathermap.org/data/2.5/weather?lat=${this.props.LatLon.lat}&lon=${this.props.LatLon.lon}&appid=${this.state.apikey}&lang=${this.props.idioma}&units=metric`
        axios.get(
            url
        )
            .then((res: { data: any }) => {
                const fecha = new Date()
                this.props.setElTiempoData({
                    temperatura: res.data.main.temp as number,
                    humedad: res.data.main.humidity as number,
                    velocidadViento: res.data.wind.speed as number,
                    descripcion: res.data.weather[0].description as string,
                    icono: res.data.weather[0].icon as string,
                    fecha: fecha.toLocaleDateString(this.props.idioma, { year: 'numeric', month: 'long', day: 'numeric' })
                })
            })
            .catch(() => {
                this.props.notify({message: this.state.text["0"], variant: 'error'})
            })
    }

    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: '100%',
                    height: "auto",
                    backgroundColor: '#f1f1f1',
                    justifyContent: "space-between"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: '100%',
                        width: '50%',
                        justifyContent: "space-between",
                        marginLeft: 20
                    }}
                >
                    <Typography
                        style={{
                            marginTop: 10,
                            fontSize: 12,
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                        }}
                    >
                        {this.props.data.fecha}
                    </Typography>

                    <Typography
                        style={{
                            fontSize: 24,
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                        }}
                    >
                        {Math.round(this.props.data.temperatura)} ºC
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row"
                        }}
                    >
                        <Typography
                            style={{fontSize: 14, fontFamily: "Poppins"}}
                        >
                            {this.state.text["1"]}
                        </Typography>
                        <Typography
                            style={{fontSize: 14, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}
                        >
                            {this.props.data.velocidadViento} km/h
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: 10
                        }}
                    >
                        <Typography
                            style={{fontSize: 14, fontFamily: "Poppins"}}
                        >
                            {this.state.text["2"]}
                        </Typography>
                        <Typography
                            style={{fontSize: 14, fontWeight: "bold", marginLeft: 10, fontFamily: "Poppins"}}
                        >
                            {this.props.data.humedad} %
                        </Typography>
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: '100%',
                        width: '50%',
                        justifyContent: "center",
                        alignItems: "revert",
                        marginLeft: 20
                    }}
                >

                    <img
                        style={{
                            marginRight: 30,
                            height: 60,
                            width: 60
                        }}
                        src={selectIcon(this.props.data.icono)}
                        alt="wthr img"
                    />
                    <Typography
                        style={{
                            marginTop: 10,
                            fontSize: 12,
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                        }}
                    >
                        {
                            this.props.data.descripcion.toUpperCase().slice(0,1)
                            +
                            this.props.data.descripcion.toLowerCase().slice(1)
                        }
                    </Typography>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state: IStore) => ({
    LatLon: state.navegacion.elTiempoLatLon,
    data: state.navegacion.elTiempoData,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setElTiempoData: (elTiempoData: IelTiempoData) => dispatch({type: "set-eltiempo_data", elTiempoData}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification})
});


export default connect(mapStateToProps, mapDispatchToProps)(ElTiempo);

